import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    parkedReceiptMain: {
        'marginTop': '10px',
        'height': 'calc(100% - 600px)',
        'minHeight': '200px',
        '@media screen and (max-height: 800px)': {
            paddingBottom: '100px'
        },
        '& > div': {
            height: '100% !important'
        }
    },
    preLoader: {
        margin: '10px 130px'
    }
});
